import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchRecipes = async (coachId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_RECIPES_LIST}/${coachId}`
    );
    return response?.data?.recipes;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch recipes");
  }
};

export const fetchFavoriteRecipes = async (coachId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.FETCH_FAVORITE_RECIPE}/${coachId}/coach`
    );
    return response?.data.data?.myFavoriteRecipes?.edges?.map(
      (edge) => edge.node
    );
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch favorite recipes");
  }
};

export const fetchRecipeAutoComplete = async (searchText) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.FETCH_AUTO_COMPLETE}/${searchText}`
    );
    return response?.data?.data?.autocomplete?.edges?.map((edge) => edge.node);
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch auto complete recipes"
    );
  }
};

export const fetchCuisines = async () => {
  try {
    const response = await axiosInstance.get(Endpoints.GET_CUISINES);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch cuisines");
  }
};

export const fetchTags = async () => {
  try {
    const response = await axiosInstance.get(Endpoints.GET_TAGS);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch Tags");
  }
};

export const fetchRecipesfilter = async ({ requestPayload, mealTime }) => {
  try {
    const toPascalCase = (str) => {
      if (!str || str.trim() === "") return "";
      const lower = str.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    };

    let normalizedMealTime = toPascalCase(mealTime);

    const response = await axiosInstance.post(
      `${Endpoints.GET_STANDARD_RECIPES}?mealType=${normalizedMealTime}`,
      {
        ...requestPayload,
      }
    );
    const rawRecipes = response?.data || [];
    const recipes = rawRecipes.map((recipe) => {
      return {
        ...recipe,
        // Ensure ingredients is an array (sometimes it's a single comma-separated string)
        ingredients: Array.isArray(recipe.ingredients)
          ? recipe.ingredients.flatMap((ing) =>
              typeof ing === "string"
                ? ing.split(";").map((s) => s.trim())
                : ing
            )
          : [],
        // Ensure instructions is an array of steps (split if provided as one string with commas)
        instructions: Array.isArray(recipe.instructions)
          ? recipe.instructions.flatMap((step) =>
              typeof step === "string"
                ? step.split(";").map((s) => s.trim())
                : step
            )
          : [],
      };
    });
    return recipes;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch recipes");
  }
};

export const PostRecipeFavoriteApi = async ({ coachId, recipeId }) => {
  try {
    const response = await axiosInstance.post(
      `${Endpoints.POST_MARK_AS_COMPLETE}/${coachId}/coach/${recipeId}`
    );
    return await response?.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to mark as favorite.");
  }
};

export const fetchRecipesById = async ({ coachId, recipeId }) => {
  try {
    const url = `${Endpoints.GET_RECIPE_BY_ID}/${coachId}/coach/${recipeId}`;
    const response = await axiosInstance.get(url);
    return response?.data?.data?.recipe;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch recipes");
  }
};
